<template>
  <div class="time-axis-box">
    <div ref="wrapper" class="ec-timeAxis"></div>
  </div>
</template>
<script>
  import { throttle, parseTime } from '@/utils'
  import * as echarts from 'echarts'
  export default {
    components: {},
    props: {
      currentTime: {
        type: Number,
        default: 0,
      },
      colors: {
        type: Array,
        default() {
          return []
        },
      },
    },
    data() {
      return {
        myChart: null,
        timeAxisOption: {
          series: [
            {
              name: '时',
              type: 'gauge',
              data: [
                {
                  value: new Date().getHours() + new Date().getMinutes() / 60,
                  name: '',
                },
              ],
              min: 0,
              max: 12,
              startAngle: 90,
              endAngle: -269.99999999999,
              splitNumber: 4,
              title: {
                show: false,
              },
              detail: {
                show: false,
              },
              splitLine: {
                length: 10,
                distance: 0,
                lineStyle: {
                  color: 'auto',
                },
              },
              axisTick: {
                distance: 0,
                length: 5,
                splitNumber: 3,
                lineStyle: {
                  // 属性lineStyle控制线条样式
                  color: 'auto',
                },
              },
              axisLabel: {
                distance: 10,
                textStyle: {
                  fontSize: 8,
                  color: '#fff',
                },
                formatter: function (val) {
                  if (val == 0) {
                    return
                  } else {
                    return val
                  }
                },
              },
              axisLine: {
                lineStyle: {
                  width: 9,
                  color: [[1, '#ccc']],
                },
              },
              pointer: {
                show: true,
                width: 1,
                length: '50%',
              },
              radius: '100%',

              itemStyle: {
                normal: {
                  color: 'rgba(255,255,255,1)',
                },
              },
              animation: false,
            },
            {
              name: '分',
              type: 'gauge',
              min: 0,
              max: 60,
              splitNumber: 60,
              center: ['50%', '50%'],
              radius: '100%',
              startAngle: 90,
              endAngle: -269.99999,
              clockWise: true,
              title: false,
              axisLine: {
                show: true,
                lineStyle: {
                  width: 0,
                },
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: true,
                formatter: function (v) {
                  switch (v + '') {
                    default:
                      return ''
                  }
                },
              },
              pointer: {
                length: '70%',
                width: 1,
              },
              detail: {
                show: false,
              },
              data: [{ value: new Date().getMinutes(), name: '分' }],
              itemStyle: {
                normal: {
                  color: 'rgba(255,255,255,1)',
                },
              },
              animation: false,
            },
          ],
        },
      }
    },
    watch: {
      currentTime: {
        handler() {
          setTimeout(() => {
            this.drawLine()
          }, 50)
        },
        immediate: true,
      },
    },
    mounted() {
      this.drawLine()
      window.addEventListener('resize', throttle(this.resize, 500))
    },
    unmounted() {
      window.removeEventListener('resize', this.resize)
    },
    methods: {
      handelColors(data) {
        var formArr = [],
          toArr = []
        if (data && data.length) {
          data.forEach((item) => {
            var hms = parseTime(item.from, '{h}:{i}:{s}')
            var c = hms.split(':')
            var t = c[0] * 60 * 60 + c[1] * 60 + c[2] * 1

            var hmsTo = parseTime(item.to, '{h}:{i}:{s}')
            var cTo = hmsTo.split(':')
            var tTo = cTo[0] * 60 * 60 + cTo[1] * 60 + cTo[2] * 1

            formArr.push(t)
            toArr.push(tTo)
          })

          var startTime = formArr[0], //开始时间
            totalTime = 12 * 60 * 60 //12小时的毫秒数

          var startArea
          if (startTime > totalTime) {
            startArea = (startTime - totalTime) / totalTime
          } else {
            startArea = startTime / totalTime
          }
          var colorArr = [[startArea, '#f1f2f7']],
            ratio = startArea,
            sColor = []
          data.forEach((val, key) => {
            if (val.state == 'Green') {
              sColor = '#24953d'
            } else if (val.state == 'Yellow') {
              sColor = '#eddc1d'
            } else if (val.state == 'Red') {
              sColor = '#e43e4a'
            } else if (val.state == 'Grey') {
              sColor = '#ccc'
            } else {
              sColor = '#fff'
            }
            var b = (toArr[key] - formArr[key]) / totalTime
            ratio = ratio + b > 1 ? ratio + b - 1 : ratio + b
            colorArr.push([ratio, sColor])
          })

          colorArr
            .sort(function (a, b) {
              return a[0] - b[0]
            })
            .push([1, '#f1f2f7'])
          return colorArr
        } else {
          return [
            [0, '#f1f2f7'],
            [1, '#f1f2f7'],
          ]
        }
      },
      drawLine() {
        if (!this.myChart) {
          this.myChart = echarts.init(this.$refs.wrapper)
        }
        let timeAxisOption = { ...this.timeAxisOption }
        timeAxisOption.series[0].axisLine.lineStyle.color = this.handelColors(
          this.colors
        )

        const elHeight = this.$refs.wrapper.clientHeight
        timeAxisOption.series[0].axisLine.lineStyle.width = elHeight / 10
        timeAxisOption.series[0].axisTick.length = elHeight / 10 - 5
        timeAxisOption.series[0].splitLine.length = elHeight / 10 - 4
        timeAxisOption.series[0].axisLabel.textStyle.fontSize = elHeight / 10

        const m = new Date(this.currentTime).getMinutes()
        const h = new Date(this.currentTime).getHours() + m / 60
        let retH = h > 12 ? h - 12 : h
        timeAxisOption.series[0].data[0].value = retH
        timeAxisOption.series[1].data[0].value = m
        this.myChart.setOption(timeAxisOption, true)
      },
      resize() {
        if (!this.$refs.wrapper) return
        echarts.init(this.$refs.wrapper).resize()
        this.drawLine()
      },
    },
  }
</script>
<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .time-axis-box {
    position: absolute;
    right: 10px;
    top: 5px;
    .triangle {
      position: absolute;
      top: 8px;
      left: 50%;
      margin-left: -5px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 5px 0;
      border-color: #5bc390 transparent;
      transform-origin: 5px 52px;
      transform: rotate(0deg);
    }
  }

  .ec-timeAxis {
    width: 80px;
    height: 80px;
    position: absolute;
    right: 0;
    top: 0;
    &:before {
      content: '';
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      border: 1px solid rgba(255, 255, 255, 0.6);
      background: @subMaster;
      left: 50%;
      top: 50%;
      margin: -2px 0 0 -2px;
      position: absolute;
      z-index: 100;
    }
  }
</style>
